// extracted by mini-css-extract-plugin
export default {"logoContainer":"HeroSection_logoContainer__Qq8-W","logo":"HeroSection_logo__wAHTO"};